module.exports = __webpack_public_path__ + "media/images/background/background-3-aeddbcf3947573a347c5669fef9b62ab.jpg";